import React, { useState } from 'react';
import { useApp } from '../context/AppContext';

export default function AddStockModal({ onClose, onSuccess }) {
  const { addStock } = useApp();
  const [form, setForm] = useState({ stockName: '', ticker: '', notes: '' });
  const [loading, setLoading] = useState(false);
  const [error, setError] = useState('');

  const handleSubmit = async (e) => {
    e.preventDefault();
    setError('');
    setLoading(true);
    try {
      await addStock(form);
      onSuccess();
    } catch (err) {
      setError(err.response?.data?.message || 'Failed to create stock');
    } finally {
      setLoading(false);
    }
  };

  return (
    <div className="modal-overlay" onClick={e => e.target === e.currentTarget && onClose()}>
      <div className="modal">
        <div className="modal-header">
          <h3>Add New Stock</h3>
          <button className="btn btn-outline btn-icon" onClick={onClose}>✕</button>
        </div>

        {error && <div className="alert alert-error">{error}</div>}

        <form onSubmit={handleSubmit}>
          <div className="form-group">
            <label>Stock Name *</label>
            <input
              type="text"
              placeholder="e.g. RELIANCE"
              value={form.stockName}
              onChange={e => setForm(f => ({ ...f, stockName: e.target.value.toUpperCase() }))}
              required
              autoFocus
              style={{ textTransform: 'uppercase' }}
            />
          </div>
          <div className="form-group">
            <label>Ticker Symbol <span style={{ color: 'var(--text-dim)', textTransform: 'none', fontWeight: 400 }}>(optional)</span></label>
            <input
              type="text"
              placeholder="e.g. RELIANCE.NS"
              value={form.ticker}
              onChange={e => setForm(f => ({ ...f, ticker: e.target.value.toUpperCase() }))}
            />
          </div>
          <div className="form-group">
            <label>Notes <span style={{ color: 'var(--text-dim)', textTransform: 'none', fontWeight: 400 }}>(optional)</span></label>
            <input
              type="text"
              placeholder="e.g. Reliance Industries Ltd"
              value={form.notes}
              onChange={e => setForm(f => ({ ...f, notes: e.target.value }))}
            />
          </div>
          <div className="modal-footer">
            <button type="button" className="btn btn-outline" onClick={onClose}>Cancel</button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Creating…' : 'Create Stock'}
            </button>
          </div>
        </form>
      </div>
    </div>
  );
}
